import { APP_STORAGE_PREFIX } from "./appStorage";

/** Studio-only checklist (payment lives on host profile / events). */
export const STUDIO_SETUP_STEPS = [
  { id: "venue", tab: "venues", label: "Add a venue", nextPhrase: "add a venue" },
  { id: "class", tab: "classes", label: "Add a class", nextPhrase: "add a class" },
  { id: "product", tab: "products", label: "Create a product", nextPhrase: "create a product" },
];

export const STUDIO_SETUP_TOTAL_STEPS = STUDIO_SETUP_STEPS.length;

const DISMISS_KEY = `${APP_STORAGE_PREFIX}school_setup_bar_dismissed_v1`;

function readDismissMap() {
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeDismissMap(map) {
  try {
    localStorage.setItem(DISMISS_KEY, JSON.stringify(map));
  } catch {
    // ignore quota / private mode
  }
}

export function isStudioSetupBarDismissed(schoolId) {
  if (!schoolId) return true;
  return Boolean(readDismissMap()[schoolId]);
}

export function dismissStudioSetupBar(schoolId) {
  if (!schoolId) return;
  const map = readDismissMap();
  map[schoolId] = Date.now();
  writeDismissMap(map);
}

export function undismissStudioSetupBar(schoolId) {
  if (!schoolId) return;
  const map = readDismissMap();
  delete map[schoolId];
  writeDismissMap(map);
}

/**
 * Progress for venue → class → product.
 * Bar hides once the school has a class and a product (operable studio).
 */
export function getStudioSetupProgress({
  venues = [],
  classes = [],
  products = [],
} = {}) {
  const doneFlags = [
    venues.length > 0,
    classes.length > 0,
    products.length > 0,
  ];
  const steps = STUDIO_SETUP_STEPS.map((step, i) => ({
    ...step,
    done: doneFlags[i],
  }));
  const completed = steps.filter((s) => s.done).length;
  const next = steps.find((s) => !s.done) || null;
  const done = classes.length > 0 && products.length > 0;
  return {
    steps,
    completed,
    total: STUDIO_SETUP_TOTAL_STEPS,
    next,
    done,
  };
}

/** Studio sub-tab for the next incomplete step. */
export function firstIncompleteStudioTab(progress) {
  return progress?.next?.tab || null;
}

/**
 * Empty studios without an active practice-setup step should re-enable the
 * top Practice setup panel when the bar CTA runs — user still lands on the
 * named Studio gap (one destination).
 */
export function shouldEnsurePracticeSetup({
  school,
  venues = [],
  classes = [],
  products = [],
} = {}) {
  const coreEmpty = venues.length === 0 && classes.length === 0 && products.length === 0;
  if (!coreEmpty || !school) return false;
  if (school.onboarding_step) return false;
  return true;
}
